<template>
  <Modal
    :title="'Raise Report'"
    v-model="isUserReportingModalOpen"
    :handleClose="handleUserReportingModal"
  >
    <div class="flex chat-modal justify-center">
      <div class="w-full">
        <div class="mb-4 text-gray-700">
          <label class="block mb-1 required">Reason </label>
          <select
            class="form-select block mt-1 w-full"
            v-model="reportingReason"
          >
            <option
              v-for="option in userReportingReasons"
              :key="option.id"
              :value="option"
            >
              {{ option.reason }}
            </option>
          </select>
          <div v-if="$v.reportingReason.$error">
            <span
              class="text-xs text-red-700"
              v-if="!$v.reportingReason.required"
            >
              Reason is required
            </span>
          </div>
        </div>

        <div class="mb-4 text-gray-700">
          <label class="block mb-1 required"> More Details </label>
          <textarea
            class="w-full h-32 px-3 py-2 text-base text-gray-700 placeholder-gray-600 ring-1 rounded-lg focus:outline-none"
            v-model="reportingDescription"
            placeholder="Share more details here."
            :class="{ 'ring-red-700': $v.reportingDescription.$error }"
          ></textarea>
          <div v-if="$v.reportingDescription.$error">
            <span
              class="text-xs text-red-700"
              v-if="!$v.reportingDescription.required"
            >
              Description is required
            </span>
            <span
              class="text-xs text-red-700"
              v-if="!$v.reportingDescription.minLength"
            >
              Description must have at least 4 letters
            </span>
          </div>
        </div>

        <div class="flex items-center justify-end space-x-2">
          <button
            class="h-8 px-4 text-sm text-gray-dark transition-colors duration-150 rounded-lg focus:shadow-outline"
            @click="handleUserReportingModal(false)"
          >
            Cancel
          </button>
          <button
            @click="handleReport"
            class="h-8 px-4 text-sm text-indigo-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline"
          >
            Report
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>
<script>
import { Modal } from "@/components/t-components";
import { required, minLength } from "vuelidate/lib/validators";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "UserReportingModal",
  components: {
    Modal,
  },
  props: {
    isUserReportingModalOpen: Boolean,
    handleUserReportingModal: Function,
    category_id: Number,
    cat_item_id: {
      type: Number,
    },
  },
  data() {
    return {
      reportingReason: "",
      reportingDescription: "",
      reportTitle: {
        1: "Report Class",
        4: "Report Chat",
      },
    };
  },
  validations: {
    reportingReason: {
      required,
    },
    reportingDescription: {
      required,
      minLength: minLength(4),
    },
  },
  computed: {
    ...mapGetters(["userReportingReasons"]),
  },
  methods: {
    ...mapActions(["getUserReportingReasons", "makeReport"]),

    async handleReport() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        console.log("invalid");
      } else {
        const payload = {
          cat_item_id: this.cat_item_id, // individual item ie post_id
          repo_cat_id: this.category_id, // category id to defined screen
          reason_id: this.reportingReason.id,
          description: this.reportingDescription,
        };
        await this.makeReport(payload);
        this.handleUserReportingModal(false);
      }
    },
  },
  async created() {
    const payload = {
      category_id: this.category_id,
    };
    await this.getUserReportingReasons(payload);
    this.reportingReason = this.userReportingReasons[0];
  },
};
</script>